import { useContext, useEffect, useState } from 'react';
import ReactPlayer from 'react-player';

import { ListS3, S3Contents } from 'types';

import { useAppSelector } from 'redux/hooks';

import { BucketContext, S3Item } from 'contexts';

import Logo from 'assets/logo-big.png';

import { Image } from 'components/Image';
import { Loader } from 'components/Loader';

import * as S from './Hero.styles';

export function Hero(): React.ReactElement {
  const { getListItems, getUrl } = useContext(BucketContext);

  const [img, imgSet] = useState<string>('');
  const [vid, vidSet] = useState<string>('');
  const [isLoading, isLoadingSet] = useState<boolean>(false);

  const { season, marketLine } = useAppSelector((state) => state.settings);

  const imageComponent = img ? (
    <Image source={img} alt="hero" />
  ) : (
    <S.Center>
      <Image asAutoSize source={Logo} alt="hero" />
    </S.Center>
  );

  const parseURL = (url: string) => {
    const extension = url.slice(-3);

    if (extension === '.db') return;

    getUrl(url)
      .then((res: S3Item) => {
        isLoadingSet(false);

        return extension === 'mp4' ? vidSet(res.url) : imgSet(res.url);
      })
      .catch(() => {
        isLoadingSet(false);
      });
  };

  useEffect(() => {
    imgSet('');
    vidSet('');
    isLoadingSet(true);

    if (season && marketLine) {
      getListItems(
        `catalogue/products/${season}/${marketLine.toLocaleLowerCase()}/home_img`
      ).then((res: ListS3) => {
        vidSet('');
        imgSet('');

        // Filter out files with "_old" in the name (e.g., "1_old.jpg")
        const filteredContents =
          res?.Contents?.filter((item: S3Contents) => {
            const fileName = item.Key.split('/').pop() || '';
            return !fileName.includes('_old');
          }) || [];

        filteredContents.forEach((item: S3Contents) => parseURL(item.Key));
      });
    }
    isLoadingSet(false);
  }, [season, marketLine]);

  return (
    <S.Hero>
      <S.HeroMedia>
        <Loader isLoading={isLoading}>
          {vid ? (
            <ReactPlayer url={vid} playing loop width="100%" height="100%" controls />
          ) : (
            imageComponent
          )}
        </Loader>
      </S.HeroMedia>
    </S.Hero>
  );
}
